import React, {Fragment} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faAngleRight, faPhone} from "@fortawesome/free-solid-svg-icons";
import {convertUTCToLocalTime, getSessionValue, timeSince} from "../../Common/Appcommon";
import cx from "classnames";
import dateFormat from "dateformat";
import CratioTooltip from "../../Common/CratioTooltip";

class DataRow extends React.Component{
    dateFieldTypeFormats = {
        'date' : "dd-mmm-yyyy",
        'Date_Time' : "dd-mmm-yyyy h:MM TT"
    }
    constructor(props) {
        super(props);
    }

    onRowSelection = async(e, rowId) => {
        let isChecked = e.target.checked;
        await this.props.onRecordSelection(isChecked, rowId);
    }

    render(){
        let {row, fields, formname,selectedRecords} = this.props;
        let field1Label = fields[0][3];
        let field1Type = fields[0][4];
        let field2Label = fields[1][3];
        let field2Type = fields[1][4];
        let field3Label = fields[2][3];
        let field3Type = fields[2][4];
        let field4Label = fields[3][3];
        let field4Type = fields[3][4];
        let assignedUser = row['Owner'];
        let rowId = row[formname+'_id'];
        let taskDate = row["Planned_Start"];
        let timediff = "";
        let isOverDue = false;
        if(taskDate != undefined && taskDate != "" && taskDate != null) {
            let currentTime = getSessionValue('currentTime');
            let currentDate = new Date(currentTime);
            let taskDateObj = new Date(taskDate);
            let currentTimeStr = Number(currentDate.getTime());
            let taskDateStr = Number(taskDateObj.getTime());
            if(currentTimeStr > taskDateStr){
                isOverDue = true;
                timediff = timeSince(taskDate,currentTime);
            } else {
                isOverDue = false;
                timediff = timeSince(currentTime,taskDate);
            }
            taskDate = convertUTCToLocalTime(taskDate,"h:MM TT, ddd, mmm dd, yyyy");
        }
        return (
            <Fragment>
                <a className={'record-view'}>
                    <div className={'card-crm crm-ripple'}>
                        <div className={'d-flex top-content'}>
                            <div className={'lhs d-flex-grow card-content-left'} onClick={(event)=>{this.props.onRowView(event,row)}}>
                                <h3 className={'m0 text-crm d-flex j-flex-start a-flex-start'}>
                                    <CratioTooltip id={1} title={field1Type == 'date' || field1Type == 'Date_Time' ? dateFormat(row[field1Label], this.dateFieldTypeFormats[field1Type]) : row[field1Label]} content={<i className={"icon-table mr5"} />} />

                                </h3>
                                <p className={'m0 text-crm-grey-dark count-row'}>
                                    <span className={'count-label'}>{field2Label}: </span>
                                    <span className={'count'}>{field2Type == 'date' || field2Type == 'Date_Time' ? dateFormat(row[field2Label], this.dateFieldTypeFormats[field2Type]) : row[field2Label]}</span>
                                </p>
                                <p className={'m0 text-crm-grey-dark-faded fs12'}>
                                    <span className={'text-crm-grey-dark last-call-status'}>{field3Label}: {field3Type == 'date' || field3Type == 'Date_Time' ? dateFormat(row[field3Label], this.dateFieldTypeFormats[field3Type]) : row[field3Label]}</span>
                                </p>
                                <p className={'m0 text-crm-grey-dark-faded fs12'}>
                                    <span className={'text-crm-grey-dark last-call-status'}>{field4Label}: {field4Type == 'date' || field4Type == 'Date_Time' ? dateFormat(row[field4Label], this.dateFieldTypeFormats[field4Type]) : row[field4Label]}</span>
                                </p>
                            </div>
                            <div className={'rhs d-flex'} onClick={(event)=>{this.props.onRowView(event,row)}}>
                                <Fragment>
                                    <div>
                                <span className="ignite-top-nav-wrap cP">
                                        <span className="top-nav-btn">
                                            <span className="profile-img-wrap">
                                            <span className="ignite-profile-image pR">
                                                <CratioTooltip id={2} title={assignedUser} content={<span className="pfbg-1 profile-bg pf-current-user">{assignedUser.substr(0,1)}</span>} />
                                            </span>
                                            </span>
                                    <FontAwesomeIcon className={'icon-custom-font'} icon={faAngleRight} size="1x" />
                                        </span>
                                </span>
                                    </div>
                                </Fragment>
                            </div>
                            <div className={'select-checkbox'}>
                                <input className={'row-select'} checked={selectedRecords.includes(rowId)} onClick={(e) => {this.onRowSelection(e, rowId)}} type={'checkbox'} />
                            </div>
                        </div>
                        <div className={cx(
                            "bottom a-flex-center  ",
                            {'hide': taskDate == '' || taskDate == null},
                        )}>
                            <div className={cx(
                                "datarow-footer  ",
                                {'text-crm-red-dark': isOverDue},
                                {'text-crm-green-dark': !isOverDue},
                            )}>
                                <div className={'call-info-long'}>
                                    <FontAwesomeIcon className={'icon-custom-font'} icon={faPhone} size="1x" />
                                    <span className={'call-time-info-long '}>Call Overdue {isOverDue ? 'by ' : 'in '}{timediff}</span>
                                </div>
                                <div className={'call-info-short'}>
                                    <span>Planned on: {taskDate}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </Fragment>
        )
    }
}

export default DataRow;
